import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api, fileUrl } from "../../lib/api";

export const Stars = ({ value, size = "w-4 h-4" }) => (
  <span className="inline-flex gap-0.5" aria-label={`${value} sur 5`}>
    {[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`${size} ${n <= Math.round(value) ? "fill-[#1C1A17] text-[#1C1A17]" : "text-black/20"}`} />)}
  </span>
);

export function Reviews({ pid }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/store/products/${pid}/reviews`).then((r) => setD(r.data)).catch(() => setD({ count: 0, items: [] }));
  }, [pid]);
  if (!d) return null;
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-10 py-16 border-t border-black/10" data-testid="product-reviews">
      <div className="flex items-baseline gap-4 mb-8">
        <h2 className="font-serif-edit text-3xl">Avis clients</h2>
        {d.count > 0 && <span className="flex items-center gap-2 text-sm" data-testid="reviews-average"><Stars value={d.average} /> {String(d.average).replace(".", ",")} / 5 · {d.count} avis</span>}
      </div>
      {d.count === 0 ? (
        <p className="text-sm text-muted-foreground max-w-xl" data-testid="reviews-empty">Aucun avis pour le moment. Seuls les clients ayant reçu ce produit peuvent laisser un avis, depuis leur commande.</p>
      ) : (
        <div className="grid md:grid-cols-2 gap-8">
          {d.items.map((r) => (
            <article key={r.id} className="border-b border-black/10 pb-6" data-testid={`review-${r.id}`}>
              <div className="flex items-center gap-3"><Stars value={r.rating} /><span className="text-xs text-muted-foreground">Achat vérifié · {r.variant_name}</span></div>
              {r.title && <h3 className="mt-3 font-medium">{r.title}</h3>}
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{r.text}</p>
              {r.photo && <img src={fileUrl(r.photo)} alt="Photo du client" className="mt-4 w-32 h-32 object-cover border border-black/10" loading="lazy" />}
              <div className="mt-3 text-xs text-muted-foreground">{r.author} · {new Date(r.created_at).toLocaleDateString("fr-CA", { dateStyle: "long" })}</div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
